<template>
  <div class="kye-report-echarts-sort"
    @click="sortClick"
    :class="{ [`kye-report-echarts-sort_${sortType}`]: true }">
    <div class="kye-report-echarts-sort_type" :class="{
        'highlight': ['asc', 'des' ].includes(sortType),
      }">
      <svg t="1700720503649" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6963" width="32" height="32"><path d="M0 1024l512-256 512 256-512-1024-512 1024z" fill="#ADADAD" p-id="6964"></path></svg>
    </div>
  </div>
</template>

<script>
export default {
    props: {
      type: String
    },
    data() {
      return {
        sortType: this.type || ''
      }
    },
    methods: {
      sortClick() {
        const { sortType } = this
        this.sortType = sortType === 'des' ? 'asc' : 'des'
        this.$emit('sort', this.sortType)
      }
    }
  }
</script>

<style lang="less" scoped>
  .kye-report-echarts-sort{
    display: flex;
    cursor: pointer;
    margin-left: 2px;
    align-items: center;
    position: relative;
    width: 8px;
    top: -2px;
    transform-origin: 4px 8px;
    &_type{
      width: 8px;
      height: 8px;
      svg{
        width: 8px;
        height: 8px;
      }
    }
    &_des{
      transform: rotate(180deg);
      top: -4px;
    }
    &_asc{
      transform: rotate(0deg);
    }
    .highlight{
      svg{
        path{
          fill: var(--g-color-primary) !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/echarts/bar-x/txt003/sort.vue